import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const baseCls = 'checkout-shortinfo-item';

const SearchParamsItem = ({ border, children, name }) => (
  <li
    className={cn(baseCls, {
      [`${baseCls}--delimiter`]: border,
      [`${baseCls}--${name}`]: name,
    })}
  >
    {children}
  </li>
);

SearchParamsItem.defaultProps = {
  border: false,
  name: '',
};
SearchParamsItem.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
};

export default SearchParamsItem;
